import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { default as ApiRequestService, default as apiRequestService } from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import TableRow from '../component/TableRow';
import styles from '../css/styles.css.js';
import subjectStyles from '../css/subjectStyle.css.js';
import { AppSetting } from '../common/function';





let hm_sub_cat = {
  hm_sub_cat_name: '',
  hm_sub_cat_id: '',
  hm_cat_id: ''
};

export default class HelpMenuSubCat extends Component {
  AppSetting = AppSetting()
  constructor(props) {
    super(props);
    this.state = {
      helpMenuSubCat: [],
      temp_helpMenuSubCat: hm_sub_cat,
      temp_id: '',
      visible: false,
      addMode: true,
      loading: true,
      instructor_name: window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
      userprofilerole : parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      hmCat_id: this.props.location.query.hm_cat_id,
      hmCat_name: this.props.location.query.hm_cat_name,
      instructorHmAccess : 0,
      editingAccess : false
    };

    this.deleteHelpMenuSubCat = this.deleteHelpMenuSubCat.bind(this);
    this.addHelpMenuSubCat = this.addHelpMenuSubCat.bind(this);
    this.getAllHelpMenuSubCat = this.getAllHelpMenuSubCat.bind(this);
    this.changeHelpMenuSubCatName = this.changeHelpMenuSubCatName.bind(this);
    this.updateHelpMenuSubCat = this.updateHelpMenuSubCat.bind(this);
    
    this.isEnterPressed = this.isEnterPressed.bind(this);    
    
    // this.errorMessageHide= this.errorMessageHide.bind(this);
  }

  componentWillMount() {
    console.debug('componentwiollmount',this.state.userprofilerole)
       this.setState({ loading: true });
       if(this.state.userprofilerole === 2){
        this.setState({editingAccess : true})
      }else{
        this.getHelpMenuAccess();
      }
      this.getAllHelpMenuSubCat();
      
    
    
  }  

  componentWillUnmount() {
    this.removeBreadCrumbs();
  }




  removeBreadCrumbs = () => {
      this.props.replaceBreadCrumb([
      ]);     
    

  };
  getHelpMenuAccess = () =>{
    const payload = {
      instructor_name: this.state.instructor_name
    };
    apiRequestService({
      method: 'post',
      url: '/getHmAccess',
      data: payload
    }).then(res => {
      if (res.data.data !== null && res.data.data !== undefined) {
        if( res.data.data.instructor_hm_access === 1){
          this.setState({
            instructorHmAccess : res.data.data.instructor_hm_access,
            editingAccess : true
          })
        }else{
          this.setState({
            instructorHmAccess : res.data.data.instructor_hm_access,
            editingAccess : false
          })
        }
      }
    })
  }
  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([
     
      {
        name: 'Help', 
        type: '', 
        onclickPath: 'helpMenuCat' 
      },
      {
        name: this.state.hmCat_name,
        type: '',
        onclickPath:
        'helpMenuSubCat?hm_cat_id=' +
        this.state.hmCat_id +
        '&hm_cat_name=' +
        this.state.hmCat_name

      }
    ]);
  };

  componentWillUpdate() {
    this.addBreadCrumbs();
  
  }

  getAllHelpMenuSubCat(){
    var hmCat_id = parseInt(this.state.hmCat_id, 10);
    const payload = {
        hm_cat_id: hmCat_id
      };
    apiRequestService({
      method: 'post',
      url: '/getAllHelpMenuSubCat',
      data: payload
  }).then(res => {
      if (res.data.data !== null && res.data.data !== undefined) {
         console.debug("getAllHelpMenuSubCat ",res.data.data)
        this.setState({
          helpMenuSubCat : res.data.data.hm_sub_cat_names,
          loading: false 
        });                     
      }
  }).catch(err =>{
      console.error('ERROR : ', err);
      NotificationManager.error(err, 'ERROR', 3000);
      this.setState({ loading: false });
      this.hide();
    
  });
  }



  addHelpMenuSubCat() {
    console.debug('Add  :' + this.state.temp_helpMenuSubCat.hm_sub_cat_name);
    /*141 Subject, Topic, Cat, Sub Cat Names should not allow empty or empty space*/
    if (
      this.state.temp_helpMenuSubCat.hm_sub_cat_name === null ||
      this.state.temp_helpMenuSubCat.hm_sub_cat_name.trim() === ''
    ) {
      alert('Please enter a valid "SubCategory name"');
      return;
    }
    this.setState({ loading: true });
    var tempHelpMenuSubCat = this.state.temp_helpMenuSubCat.hm_sub_cat_name.trim();
    var hmCat_id = parseInt(this.state.hmCat_id, 10);
    const payload = {
      hm_sub_cat_name: tempHelpMenuSubCat,
      hm_cat_id: hmCat_id
      
      
    };
    ApiRequestService({
      method: 'post',
      url: '/addHelpMenuSubCat',
      data: payload
    }).then(res => {
      if (res.data.message !== null && res.data.message !== '') {
        console.error('ERROR : ', res.data.message);
        // Bug id #143 fixed
        this.setState({ loading: false });
        this.hide();
        NotificationManager.error(res.data.message, 'ERROR', 3000);
        return;
      }

      if (res.data.data != null) {
        console.debug('response : ', res);
        let tempHelpMenuSubCat;
        if(this.state.helpMenuSubCat === null ||this.state.helpMenuSubCat === undefined){
          tempHelpMenuSubCat=[];
        }else{
          tempHelpMenuSubCat = this.state.helpMenuSubCat;
        }
        tempHelpMenuSubCat.push({
          hm_sub_cat_name: res.data.data.hm_sub_cat_name,
          hm_sub_cat_id: res.data.data.hm_sub_cat_id,
          hm_cat_id: res.data.data.hm_cat_id
        });
        this.setState({
          helpMenuSubCat: tempHelpMenuSubCat
        });
      }
      this.setState({
        loading: false
      });
      this.hide();
    });
  }

  editHelpMenuSubCat(id) {
    this.setState({
      temp_helpMenuSubCat: this.state.helpMenuSubCat[id],
      temp_id: id,
      addMode: false
    });
    this.show(false);
  }

  updateHelpMenuSubCat() {
    this.setState({ loading: true });
    console.debug('Editing  :' + this.state.temp_helpMenuSubCat);

    var hmCat_id = parseInt(this.state.hmCat_id, 10);
    const payload = {
      hm_sub_cat_id: this.state.temp_helpMenuSubCat.hm_sub_cat_id,
      hm_sub_cat_name: this.state.temp_helpMenuSubCat.hm_sub_cat_name,
      hm_cat_id: hmCat_id
    };
    ApiRequestService({
      method: 'post',
      url: '/updateHelpMenuSubCat',
      data: payload
    }).then(res => {
      if(res.data.message !== null && res.data.message !== ""){
        if(res.data.message.toLowerCase().indexOf("duplicate")>=0){
            NotificationManager.error("Duplicate entry. Already Exists", 'Error Message', 5000);
            this.setState({loading: false
            });
        }else{
            NotificationManager.error(res.data.message, 'Error Message', 5000);
            this.setState({loading: false
            });
        }
    } else {
        NotificationManager.success('SubCategory Added', 'Success');
    
        console.debug(res);
        console.debug('Update State: ', this.state.helpMenuSubCat);
        this.setState({
          helpMenuSubCat: this.state.helpMenuSubCat,
          temp_helpMenuSubCat: hm_sub_cat,
          loading: false
        });
        
    }
    });
    this.hide();
    this.getAllHelpMenuSubCat();
  }
  deleteHelpMenuSubCat(id) {
    this.setState({ loading: true });
    console.debug(
      'Deleting hm_sub_cat i:' + id + ' id: ' + this.state.helpMenuSubCat[id].hm_sub_cat_id
    );
    var hmCat_id = parseInt(this.state.hmCat_id, 10);
    const payload = {
      hm_sub_cat_id: this.state.helpMenuSubCat[id].hm_sub_cat_id,
      hm_cat_id: hmCat_id
    };
    ApiRequestService({
      method: 'post',
      url: '/deleteHelpMenuSubCat',
      data: payload
    })
      .then(res => {
        console.debug(res);
        //window.localtion.reload();
        this.state.helpMenuSubCat.splice(id, 1);
        console.debug('Spliced Array', this.state.helpMenuSubCat);
        this.setState({
          helpMenuSubCat: this.state.helpMenuSubCat,
          loading: false
        });
      })
      .catch(error => {
        //bug-tracker#162

        console.error('Error When Deleting ', error);
        if (error.status !== undefined && error.status === 403) {
          //User Doesnt Have Access
          NotificationManager.error(
            'Unauthorized',
            'You are not authorized to delete hm_sub_cat',
            5000
          );
        }
        this.setState({
          loading: false
        });
      });
  }
  changeHelpMenuSubCatName(e) {
    console.debug("changeHelpMenuSubCatName ",e)
    let curHelpMenuSubCatName = this.state.temp_helpMenuSubCat;
    curHelpMenuSubCatName.hm_sub_cat_name = e;
    this.setState({
      temp_helpMenuSubCat: curHelpMenuSubCatName
    });
  }

  show = isAddDialogEnable => {
    //

    if (isAddDialogEnable) {
      this.setState({
        temp_helpMenuSubCat: {
          hm_sub_cat_name: '',
          hm_sub_cat_id: ''
        }
      });
    }
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({
      visible: false,
      addMode: true
    });
  };
  
  delete = id => {
   
    confirmAlert({
      title: 'Are you sure want to delete this?',
      message: 'Press Confirm to submit',
      confirmLabel: 'Cancel',
      cancelLabel: 'Confirm',

      onCancel: () => this.deleteHelpMenuSubCat(id)
      //   onCancel: () => ,
    });
  };

  isEnterPressed(event){
    var code = event.keyCode || event.which;
    console.debug(event)
    if(code === 13) { //13 is the enter keycode
      if (this.state.addMode) {
        this.addHelpMenuSubCat()
      } else{
        this.updateHelpMenuSubCat();
      }
    }
  }

  render() {
    let button = null;
    if (this.state.addMode) {
      button = (
        <button style={styles.addButton} onClick={this.addHelpMenuSubCat}>
          Add 
        </button>
      );
    } else {
      button = (
        <button style={styles.addButton} onClick={this.updateHelpMenuSubCat}>
          Update 
        </button>
      );
    }
    var cancelButton = (
      <button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);
    var tableRows = (this.state.helpMenuSubCat != null
      ? this.state.helpMenuSubCat.map((hm_sub_cat, i) => (
        
        
          <TableRow
            key={hm_sub_cat.hm_sub_cat_id}
            data={hm_sub_cat}
            id={hm_sub_cat.hm_sub_cat_id}
            name={hm_sub_cat.hm_sub_cat_name}
            title={'Help SubCategory'}
            type={''}
            url={
              'HelpMenu?hm_sub_cat_id=' +
              hm_sub_cat.hm_sub_cat_id +
              '&hm_sub_cat_name=' +
              hm_sub_cat.hm_sub_cat_name +
              '&hm_cat_id=' +
              this.state.hmCat_id +
              '&hm_cat_name=' +
              this.state.hmCat_name
            }
            onEditClick={() => this.editHelpMenuSubCat(i)}
            pushId={'hm_sub_cat'}
            onDeleteClick={() => this.delete(i)}
            instructorSubject={this.state.editingAccess ?  true : false}
          />
        ))
      : '')

    return (

      (this.state.loading)?
         <LoadingSpinner loading={this.state.loading} />
      :
      <SecureShow targetRole={1}>

        <div style={{ width: '90%' }}>
          <div style={styles.subjectTitle}>
            Help SubCategory
            <div style={this.state.editingAccess ? {float: "right"}:{display:"none"}}>
              <Button className="archive-button" primary raised
              style={{float: "right" }}
                onClick={() => this.show(true)}>
                  Add a Help SubCategory
              </Button>
            </div>
          </div>
          <div>
            {
              <DialogContainer
                id="simple-action-dialog"
                visible={this.state.visible}
                onHide={this.hide}
                actions={actions}
                //title="New Subject"
                width="500px"
              >
              <p style={{fontSize:"medium"}}><b><label for="hmId">Help SubCategory</label></b></p>
                <TextField
                  id="hmId"
                  name="hm_sub_cat_name"
                  defaultValue={this.state.temp_helpMenuSubCat.hm_sub_cat_name || ''}
                  onChange={this.changeHelpMenuSubCatName}
                  style={subjectStyles.dialogText}
                  onKeyPress={this.isEnterPressed.bind(this)}              
                />
              </DialogContainer>
            }
          </div>
          <table style={styles.subjectTable}>
            <thead style={styles.thead}>
              <tr>
                <th>ID</th>
                <th>SubCategory</th>
                {this.state.editingAccess ? (<th>Actions</th>):("")}
              </tr>
            </thead>

            <tbody>
              {tableRows}
            </tbody>
          </table>
        </div>
        
      </SecureShow>
    );
  }
}
